// COMPONENT IMPORTS
import { apiInstance } from "store/api/axiosApi";
import {
  GET_PRODUCTS,
  GET_SUBSCRIPTION_COUNT,
  GET_SUBSCRIPTION_HISTORY,
  GET_DUE_AMOUNT,
  UPDATE_SUBSCRIBE_PLAN,
  CANCEL_SUBSCRIBE_PLAN,
  GET_INVOICE_DETAILS,
  SEND_INVOICE,
  INVOICE_UPDATE,
  GET_QUOTE_DETAILS,
  ACCEPT_QUOTE,
  DECLINE_QUOTE,
  CHARGE_CUSTOMER,
  INVOICE_PAYMENT,
  SEND_EMAIL_DECLINE_QUOTE,
  SEND_EMAIL_ACCEPT_QUOTE,
  DONT_CANCEL_SUBSCRIBE_PLAN,
  UPDATE_SUBSCRIBE_PAYMENT_METHOD,
  GET_PENDING_SUBSCRIPTION_DETAILS,
  UPDATE_PLAN_PENDING_SCHEDULE,
  CHECK_ACCOUNT_ACTIVE_SUBSCRIPTION,
} from "store/api/constApi";
import { withSlug } from "utils/currentSlug";

/* ------------------------------------- SUBSCRIPTION SERVICES ------------------------------------- */

export const getSubscriptionCount = (params: any) => {
  return apiInstance.get(GET_SUBSCRIPTION_COUNT, { params });
};

export const getSubscriptionHistory = (payload: any) => {
  return apiInstance.post(GET_SUBSCRIPTION_HISTORY, payload);
};

export const checkAccountActiveSubscription = (payload: any) => {
  return apiInstance.post(CHECK_ACCOUNT_ACTIVE_SUBSCRIPTION, payload);
};

export const getProducts = (params: any) => {
  return apiInstance.get(GET_PRODUCTS, { params });
};

export const getDueAmount = (payload: any) => {
  return apiInstance.post(GET_DUE_AMOUNT, payload);
};

export const updateSubscribePlan = (payload: any) => {
  return apiInstance.post(UPDATE_SUBSCRIBE_PLAN, payload);
};

export const cancelSubscribePlan = (payload: any) => {
  return apiInstance.post(CANCEL_SUBSCRIBE_PLAN, payload);
};

export const dontCancelSubscribePlan = (payload: any) => {
  return apiInstance.post(DONT_CANCEL_SUBSCRIBE_PLAN, payload);
};

export const updateSubsPaymentMethod = (Payload: any) => {
  return apiInstance.post(UPDATE_SUBSCRIBE_PAYMENT_METHOD, Payload);
};

export const getPendingSubscriptionDetails = async (params: any) => {
  return apiInstance.get(GET_PENDING_SUBSCRIPTION_DETAILS, { params });
};

export const updatePendingSubscription = async (payload: any) => {
  return apiInstance.post(UPDATE_PLAN_PENDING_SCHEDULE, payload);
};

export const getInoviceDetails = (params: any) => {
  return apiInstance.get(GET_INVOICE_DETAILS, { params });
};

export const sendInvoiceEmail = (payload: any) => {
  return apiInstance.post(SEND_INVOICE, payload);
};

export const makeInvoiceUpdate = (payload: any) => {
  return apiInstance.post(INVOICE_UPDATE, payload);
};

export const makeInvoicePayment = (payload: any) => {
  return apiInstance.post(INVOICE_PAYMENT, payload);
};

export const getQuotesDetails = (params: any) => {
  return apiInstance.get(GET_QUOTE_DETAILS, { params });
};

export const acceptQuotes = (params: any) => {
  return apiInstance.get(ACCEPT_QUOTE, { params });
};

export const declineQuotes = (params: any) => {
  return apiInstance.get(DECLINE_QUOTE, { params });
};

export const chargeCustomer = (payload: any) => {
  return apiInstance.post(CHARGE_CUSTOMER, withSlug(payload));
};

export const sendEmailDeclineQuotes = (payload: any) => {
  return apiInstance.post(SEND_EMAIL_DECLINE_QUOTE, payload);
};

export const sendEmailAcceptQuotes = (payload: any) => {
  return apiInstance.post(SEND_EMAIL_ACCEPT_QUOTE, payload);
};
